import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhonePipe } from './phone.pipe';
import { RelativeTimePipe } from './relative-time.pipe';
import { ShortNumberPipe } from './short-number.pipe';
import { CapitalizePipe } from './capitalize.pipe';
import { NumberFormatterPipe } from './number-formatter.pipe';
import { MomentFormatPipe } from './moment-format.pipe';
import { MsConvertPipe } from './ms-convert.pipe';
import { UtilsPipe } from './utils.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedDatePipe } from './localized-date.pipe';
import { IbFixPipe } from './ib-fix.pipe';
import { OxioCurrencyPipe } from './oxio-currency.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { EnumeratePipe } from './enumerate.pipe';
import { FinalPricesRangePipe } from './final-prices-range.pipe';
import { SortMapPipe } from './sort-map.pipe';
import { DataRangeTrafficLabelIdPipe } from 'src/app/shared/pipes/data-range-traffic-label-id.pipe';
import { TrafficLabelLogoNamePipe } from 'src/app/shared/pipes/traffic-label-logo-name.pipe';

@NgModule({
  declarations: [
    PhonePipe,
    RelativeTimePipe,
    ShortNumberPipe,
    CapitalizePipe,
    NumberFormatterPipe,
    MomentFormatPipe,
    MsConvertPipe,
    UtilsPipe,
    LocalizedDatePipe,
    IbFixPipe,
    OxioCurrencyPipe,
    SafeHtmlPipe,
    EnumeratePipe,
    FinalPricesRangePipe,
    DataRangeTrafficLabelIdPipe,
    TrafficLabelLogoNamePipe,
    SortMapPipe,
  ],
  imports: [CommonModule],
  exports: [
    PhonePipe,
    RelativeTimePipe,
    ShortNumberPipe,
    CapitalizePipe,
    NumberFormatterPipe,
    MomentFormatPipe,
    MsConvertPipe,
    UtilsPipe,
    LocalizedDatePipe,
    IbFixPipe,
    OxioCurrencyPipe,
    SafeHtmlPipe,
    EnumeratePipe,
    FinalPricesRangePipe,
    DataRangeTrafficLabelIdPipe,
    TrafficLabelLogoNamePipe,
    SortMapPipe,
  ],
  providers: [
    TranslateModule,
    LocalizedDatePipe,
    DataRangeTrafficLabelIdPipe,
    IbFixPipe,
    NumberFormatterPipe,
  ],
})
export class PipesModule {}
